import { AsyncPipe } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { RecentItem } from '@compiere-ws/models/compiere-recent-item';
import { RecentItemsManagerService } from '@iupics-manager/managers/recent-items-manager/recent-items-manager.service';
import { UICreatorService } from '@iupics-manager/managers/ui-creator/ui-creator.service';
import { WorkspaceService } from '@web-desktop/components/workspace/components/workspace-ui/workspace.service';
import { IupicsMenuType } from '@web-desktop/models/menu-item-ui';
import { Observable } from 'rxjs';
import { AbstractWidgetComponent } from '../../abstract-widget.component';

@Component({
  selector: 'iu-recent-item-widget-ui',
  templateUrl: './recent-item-widget-ui.component.html',
  styleUrls: ['./recent-item-widget-ui.component.scss'],
  standalone: true,
  imports: [AsyncPipe],
})
export default class RecentItemWidgetUiComponent extends AbstractWidgetComponent implements OnInit {
  recentItems$: Observable<RecentItem[]>;
  #workspaceService = inject(WorkspaceService);

  constructor(
    private riManager: RecentItemsManagerService,
    uiCreatorService: UICreatorService
  ) {
    super(uiCreatorService);
  }

  ngOnInit(): void {
    this.updateWidget();
  }

  updateWidget(): void {
    this.recentItems$ = this.riManager.getRecentItems();
  }

  openTab(event: Event, item: unknown): void {
    const recentItem = item as RecentItem;
    event.stopPropagation();
    const source = {
      id: recentItem.entityKey,
      menuType: IupicsMenuType.WINDOW,
    };
    this.#workspaceService.openTargetSearchEmt.emit({
      zoomInfo: null,
      cat: { id: recentItem.entityID },
      source,
      ctx: null,
    });
  }
}
